import React, { useState, useEffect } from 'react';
import { Box, Card, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import formatSchedule, { generateTestSchedules } from '../../utils/formatSchedule';
import axios from 'axios';
import apiClient from '../../api/client';
import useAuthToken from '../../hooks/useAuthToken';

// This component is for testing schedule formatting
const TestSchedules = () => {
  const [automations, setAutomations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = useAuthToken();

  useEffect(() => {
    // Generate test schedule data
    const testSchedules = generateTestSchedules();

    // Also fetch real automations to test with real data
    if (token) {
      setIsLoading(true);
      apiClient.get('/automations', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(res => {
        console.log('Raw automations data from API:', res.data);
        
        // Map raw data to our format for testing
        const mappedAutomations = res.data.map(automation => ({
          id: automation.id,
          title: automation.title || 'Unnamed',
          scheduleType: automation.schedule_type,
          scheduleInterval: automation.schedule_interval,
          scheduleTime: automation.schedule_time,
          scheduleDays: automation.schedule_days,
          scheduleDay: automation.schedule_day
        }));
        
        // Combine test and real data
        setAutomations([...testSchedules, ...mappedAutomations]);
      }).catch(err => {
        console.error('Error fetching automations:', err);
        setAutomations(testSchedules);
      }).finally(() => {
        setIsLoading(false);
      });
    } else {
      setAutomations(testSchedules);
      setIsLoading(false);
    }
  }, [token]);

  if (isLoading) {
    return <div>Loading schedule test data...</div>;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Schedule Formatting Tests
        </Typography>

        <Card sx={{ p: 2, mb: 4 }}>
          <Typography variant="body1">
            This page tests the schedule formatting utility with various schedule configurations.
          </Typography>
        </Card>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Schedule Title</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Interval</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Days/Day</TableCell>
                <TableCell>Raw Time Type</TableCell>
                <TableCell>Formatted Result</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {automations.map((schedule, index) => {
                // Log details about the schedule
                console.log(`Testing schedule #${index}:`, {
                  title: schedule.title,
                  scheduleType: schedule.scheduleType,
                  scheduleTime: schedule.scheduleTime,
                  typeOf: typeof schedule.scheduleTime
                });
                
                const formattedSchedule = formatSchedule(schedule);
                
                return (
                  <TableRow key={index}>
                    <TableCell>{schedule.title}</TableCell>
                    <TableCell>{schedule.scheduleType}</TableCell>
                    <TableCell>{schedule.scheduleInterval}</TableCell>
                    <TableCell>
                      {schedule.scheduleTime !== null && schedule.scheduleTime !== undefined 
                        ? `"${schedule.scheduleTime}"` 
                        : 'null'}
                    </TableCell>
                    <TableCell>
                      {schedule.scheduleType === 'WEEKLY'
                        ? JSON.stringify(schedule.scheduleDays)
                        : schedule.scheduleType === 'MONTHLY'
                          ? schedule.scheduleDay
                          : '-'}
                    </TableCell>
                    <TableCell>{typeof schedule.scheduleTime}</TableCell>
                    <TableCell><strong>{formattedSchedule}</strong></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};

export default TestSchedules; 